import React from "react";
import Header from "../include/header";
import Footer from "../include/footer";
import LeftPanel from "../include/leftpanel";
import { useNavigate } from "react-router-dom";

function WarehouseScannerDetails(){
    const navigate = useNavigate();
    return(
        <>
        <LeftPanel/>
        <main className='home-section'>
            <Header/>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                <div className="d-block mb-6 mb-md-0">
                    <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
                        <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
                            <li className="breadcrumb-item">
                                <a href="/Admin-Dash">
                                <i className="bx bx-home text-primary-400 fs-6"></i>
                                </a>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">Warehouse Inbound Scanner</li>
                        </ol>
                    </nav>
                    <div className="d-flex justify-content-between">
                        <div className="">
                            <button className="btn btn_nav btn-sm" type="button" onClick={() => navigate(-1)}>
                            <i className="bx bx-arrow-back "></i>
                            </button>
                        </div>
                        <div className="ps-2 ">
                            <h2 className="h4">Warehouse Inbound Scanner</h2>
                        </div>
                    </div>
                </div>
                
                <div className="btn-toolbar mb-2 mb-md-0">
                    
                </div>
            </div>


            

            <div className="row menus_v">
                <div className="col-12 col-md-3">
                    <a href="/WarehouseScannerPickup">
                        <div className="card">
                            <div className="card-body">
                                <h4><i className="bx bx-collection"></i></h4>
                                <h2>Scan Pickup Shipments</h2>
                                <p>Arrival of shipments picked up by drivers or messengers into the warehouse</p>
                            </div>
                        </div>
                    </a>
                </div>
                <div className="col-12 col-md-3">
                    <a href="">
                        <div className="card">
                            <div className="card-body">
                                <h4><i className="bx bx-cuboid"></i></h4>
                                <h2>Scan Bags</h2>
                                <p>Arrival of bags manifested by one location to another location into the warehouse</p>
                            </div>
                        </div>
                    </a>
                </div>
                <div className="col-12 col-md-3">
                    <a href="">
                        <div className="card">
                            <div className="card-body">
                                <h4><i className="bx bx-cube-alt"></i></h4>
                                <h2>Scan Manifest Shipments</h2>
                                <p>Arrival of shipments manifested from one location to another location into the warehouse</p>
                            </div>
                        </div>
                    </a>
                </div>
                <div className="col-12 col-md-3">
                    <a href="">
                        <div className="card">
                            <div className="card-body">
                                <h4><i className="bx bx-run"></i></h4>
                                <h2>Scan Delivery Shipments</h2>
                                <p>RTO or Rescheduled shipments by drivers or messengers into the warehouse</p>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
            <Footer/>
        </main>
        </>

    );
}
export default WarehouseScannerDetails;